import React, { useEffect } from "react";
import Button from "../../button/Button";
import { ROUTE_PATH } from "userful-chronos-app-common-js/dist/routing";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrochipAi, faExternalLink, faMultiply } from "@fortawesome/pro-regular-svg-icons";
import {
    useEisenhowerSelector,
    EisenhowerProvider,
    useEisenhowerDispatch,
    eisenhowerActions,
} from "userful-chronos-common-store/dist/eisenhower";
import Cookies from "js-cookie";
import "./AnomalyNotificationCard.scss";

interface IProps {}

const AnomalyNotificationCard = (props: IProps) => {
    const { t } = useTranslation();
    const dispatch = useEisenhowerDispatch();
    const showAnomalyAlert = useEisenhowerSelector((state) => state.eisenhowerStore.showAnomalyAlert);

    const redirectToInfinityEdgeAI = () => {
        window.location.href = `${ROUTE_PATH.APP.UCONTROL}?navigation=REQUSTS`;
    };

    const onCancel = () => {
        dispatch(eisenhowerActions.setShowAnomalyAlert(false));
    };

    const handleHide = (e) => {
        e.preventDefault();
        Cookies.set("hideAnomalyAlert", "true", { expires: 30 });
        onCancel();
    };

    return (
        <div className={showAnomalyAlert ? "anomalyNotificationCard" : "anomalyNotificationCard hideAlert"}>
            <div className="anomalyNotificationCard_content_row">
                <div className="anomalyNotificationCard_content">
                    <div className="titleIconContainer">
                        <FontAwesomeIcon icon={faMicrochipAi} className="iconContainer" />
                        <div className="anomalyNotificationCard_title">
                            {t("PresetSwticher.Requests.AnomalyDetected")}
                        </div>
                    </div>
                    <div className="anomalyNotificationCard_message">
                        {t("PresetSwticher.Requests.AnomalyDetectedDes")}
                    </div>
                </div>
                <Button variant="secondary" onClick={() => onCancel()}>
                    <FontAwesomeIcon icon={faMultiply} />
                </Button>
            </div>
            <div className="anomalyNotificationCard_content_row">
                <div className="buttonContainer">
                    <Button variant="secondary" onClick={redirectToInfinityEdgeAI}>
                        {t("PresetSwticher.Requests.ViewRequest")}{" "}
                        <FontAwesomeIcon icon={faExternalLink} style={{ marginLeft: "8px" }} />
                    </Button>
                    <Button variant="secondary" onClick={() => onCancel()}>
                        {t("Shared.cancel")}
                    </Button>
                </div>
                <div className="dontshow">
                    <a href="#" onClick={handleHide}>
                        {t("PresetSwticher.Requests.DontShow")}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AnomalyNotificationCard;
